import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/reviews`).then((r) => {
      setData(r.data);
      if (r.data.count > 0) {
        const ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "reviews-ld";
        ld.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          name: "NOXWAY Formula 100 — Wildfire Protection Gel (5kg Bag)",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: r.data.average,
            reviewCount: r.data.count,
          },
        });
        document.head.appendChild(ld);
      }
    }).catch(() => setData({ reviews: [], count: 0 }));
    return () => document.getElementById("reviews-ld")?.remove();
  }, []);

  if (!data || data.count === 0) return null;

  return (
    <section className="py-20 lg:py-28 bg-[#faf9f7]" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-12"
        >
          <div className="font-tech text-[11px] tracking-[0.3em] text-[#f97316] uppercase mb-4">Verified owners</div>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-[#17150f] mb-4">
            Trusted at the fire line.
          </h2>
          <div className="flex items-center gap-2" data-testid="reviews-average">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star key={n} size={18} className={n <= Math.round(data.average) ? "text-[#f97316] fill-[#f97316]" : "text-stone-300"} />
            ))}
            <span className="text-sm text-stone-500 ml-2">{data.average} / 5 · {data.count} review{data.count > 1 ? "s" : ""}</span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-testid="reviews-list">
          {data.reviews.slice(0, 6).map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="rounded-xl border border-stone-200 bg-white p-7"
            >
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} size={14} className={n <= r.rating ? "text-[#f97316] fill-[#f97316]" : "text-stone-300"} />
                ))}
              </div>
              <p className="text-sm text-stone-700 leading-relaxed mb-5">“{r.text}”</p>
              <div className="font-tech text-[10px] tracking-[0.15em] uppercase text-stone-400">
                {r.name || "Verified owner"}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
